import { ArrowForward, Close } from "@mui/icons-material";
import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { appStates, setAppState } from "../redux/features/appStateSlice";
import { resetMarkerCount } from "../redux/features/coverageSlice";
import { updateForm } from "../redux/features/formStateSlice";
import { EBenefitTypes, createOrUpdateMyLocation } from "../utils";
import { LoaderComponent } from "./Loader";
import { BaseDialog } from "./common/BaseDialog";
import { SnackbarAlert } from "./common/SnackbarAlert";
import { MapComponent } from "./coverageAreaMap";
import { transformPayloadCoverage } from "./transformPayloadCoverage";

const styles = {
  titleSx: {
    fontWeight: "bold",
  },
  actionSx: {
    justifyContent: "center",
  },
  btnCloseSx: {
    backgroundColor: "grey",
    color: "white",
    "&:hover": { backgroundColor: "var(--fx-surface-sidebar, #233044)" },
    margin: "0 8px",
  },
  btnAcceptSx: {
    backgroundColor: "#3c7cde",
    color: "white",
    "&:hover": { backgroundColor: "var(--fx-surface-sidebar, #233044)" },
    margin: "0 8px",
  },
};

export const ConnectBusinessCoverageArea = ({ updateEntityState, entityState }) => {
  const userState = useSelector((state) => state.userState);
  const currPage = "/connect";
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isFormValid, setIsFormValid] = useState(false);
  const [data, setData] = useState([]);
  const [changes, setChanges] = useState(false);
  const [cancel, setCancel] = useState(false);
  const token = sessionStorage.getItem("token");
  const [openInsufficientBenefits, setOpenInsufficientBenefits] = React.useState(false);
  const [updated, setUpdated] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlerSeverity] = useState("");

  const markerState = useSelector((state) => state.markerState);

  const benefitType = EBenefitTypes.AREASCOVERAGES;

  const usersBenefits =
    userState?.benefits?.findLast((benefit) => {
      if (benefit?.type === benefitType) {
        return true;
      }
      return false;
    }) ?? null;

  useEffect(() => {
    dispatch(updateForm({ state: "businessInformation" }));
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 200);
    return () => clearTimeout(timeout);
  }, [dispatch]);

  const handleResetParentStates = () => {
    setCancel(false);
    setChanges(false);
  };

  const handleOpenInsufficientBenefitsDialog = () => {
    setOpenInsufficientBenefits(true);
  };

  const handleCbActionFactory = () => {
    // if (usersBenefits?.UserBenefits?.usageCount < usersBenefits?.config?.limitedUsage) {
    return handleSubmit;
    // } else {
    //   alert("ahahahahaah");
    //   return handleOpenInsufficientBenefitsDialog;
    // }
  };

  const handleSubmit = async () => {
    try {
      setOpen(true);
      handleResetParentStates();
      setUpdated(!updated);
      setAlertMessage("Coverage areas updated");
      setAlerSeverity("success");
    } catch (error) {
      console.error(error);
      setAlertMessage("Error updating coverage areas" + error);
      setAlerSeverity("error");
      handleOpenInsufficientBenefitsDialog();
    } finally {
      setOpenAlert(true);
      setOpen(false);
    }
  };

  const handleUpdateMyAreas = async (areas) => {
    const payload = transformPayloadCoverage(areas);
    const res = await createOrUpdateMyLocation(token, payload, usersBenefits?.UserBenefits?.id);
    console.log(res);
  };

  const actions = [
    {
      label: "Close",
      onClick: () => {
        setOpenInsufficientBenefits(false);
      },
      icon: <Close></Close>,
      style: styles.btnCloseSx,
    },
    {
      label: "Go to plans",
      onClick: () => {
        navigate("/business/plan-center");
        dispatch(
          setAppState({
            currState: appStates.PLANS,
          })
        );
        dispatch(resetMarkerCount());
      },
      icon: <ArrowForward></ArrowForward>,
      style: styles.btnAcceptSx,
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "auto",
        width: "100%",
        height: "100%",
      }}
    >
      <Box
        style={{
          borderRadius: "10px",
          backgroundColor: "var(--fx-surface-sunken, #F8FAFC)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          transition: "opacity 1s ease-in-out",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          height: "100%",
        }}
        sx={{
          marginTop: { xs: "15%", md: 0 },
          width: { xs: "100%", md: "100%", lg: "100%" },
          height: { xs: "100%", md: "100%", lg: "100%" },
        }}
      >
        <Grid
          item
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* TODO: Coverage area */}
          <MapComponent
            handleUpdateMyAreas={handleUpdateMyAreas}
            updateEntityState={updateEntityState}
            entityState={entityState}
            setChanges={setChanges}
            setLoading={setOpen}
            refresh={cancel}
            refreshCb={handleResetParentStates}
            setData={setData}
            updated={updated}
            setCancel={setCancel}
            handleCbActionFactory={handleCbActionFactory}
            changes={changes}
          ></MapComponent>
        </Grid>
      </Box>

      <BaseDialog
        openState={openInsufficientBenefits}
        setOpenState={setOpenInsufficientBenefits}
        title="Benefits Limit Reached!"
        titleSx={styles.titleSx}
        content="You don't have the required benefits or you've exceeded the usage limit to perform this action. Please review your plan for details or contact support for assistance."
        actionSx={styles.actionSx}
        actions={actions}
      ></BaseDialog>
      <SnackbarAlert
        openState={openAlert}
        setOpenState={setOpenAlert}
        severity={alertSeverity}
        duration={4500}
        message={alertMessage}
      ></SnackbarAlert>
      <LoaderComponent open={open}></LoaderComponent>
    </Box>
  );
};
